import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, SxProps } from "@mui/material";

interface IDialog {
  open: boolean;
  toggleDialog: () => void;
  title: string;
  message: string | React.ReactNode;
  buttonText?: string;
  classes?: SxProps;
  disable?: boolean; //added
}

const CustomDialog = ({
  open,
  classes = {},
  toggleDialog,
  title,
  message,
  buttonText = "Ok",
  disable, //added
}: IDialog) => {
  return (
    <Dialog open={open} disableScrollLock={true} sx={classes}>
      <DialogTitle id="alert-dialog-title" color={"dsBase.v200"}>{title}</DialogTitle>
      <DialogContent
        sx={{
          minWidth: "300px",
        }}
      >
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={toggleDialog} color="primary" autoFocus disabled={disable}>
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
